import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'newheader',
  templateUrl: './newheader.component.html',
  styleUrls: ['./newheader.component.scss']
})
export class NewheaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
